import link from '~/components/atoms/a-links/a-link-v2.data'
import copy from '~/components/atoms/a-copy/a-copy.data'

export default {
  content_left: [
    {
      ...copy,
      heading: 'Hello from London.',
      heading_size: 'h3',
    },
    {
      ...copy,
      copy: 'United Kingdom',
    },
    {
      ...copy,
      copy:
        "<p>We'd love to hear from you. Our doors are always open to new " +
        'collaborations and opportunities.</p>',
    },
    {
      ...link,
      copy: 'View on map',
      target: '_blank',
      href: {
        url: '/',
        cached_url: '/',
      },
    },
  ],
  content_middle: [
    {
      ...copy,
      heading: 'New business enquiries',
      copy: '<p>Jamie Willey<br /><a href="mailto:jamie.willey@tribalworldwide.co.uk">jamie.willey@tribalworldwide.co.uk</a></p>',
    },
  ],
  content_right: [
    {
      ...copy,
      heading: 'Press & Media enquiries',
      copy: '<p>Sarah Owen<br /><a href="tel:+442072872007">+44 207 287 2007</a></p>',
    },
  ],
}
